/**
 * This is the entry file for webpack/config/front.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();

// Cookies
import '/node_modules/vanilla-cookieconsent/dist/cookieconsent.js';

// Bootstrap
import '/webpack/assets/js/bootstrap.bundle.min.js';

// Gallery
import '/node_modules/lightgallery/dist/js/lightgallery.min.js';
import '/node_modules/lg-zoom/dist/lg-zoom.min.js';
import '/node_modules/lg-thumbnail/dist/lg-thumbnail.min.js';

// Application
// import '/webpack/assets/js/netteFormsExtension.js';
import '/webpack/assets/js/nette.ajax.js';
import '/webpack/assets/js/youtube.js';
import '/webpack/assets/js/front/gallery.js';
import '/webpack/assets/js/front/general.js';

$(function() {
	$.nette.init();
});
